import React from 'react'

interface TextBalloonProps {
  children: React.ReactNode
  className?: string
  ballonClassName?: string
}

const TextBalloon: React.FC<TextBalloonProps> = ({ children, className, ballonClassName }) => (
  <div className={`portrait:hidden landscape:absolute bottom-7 mb-2 flex flex-col items-center pointer-events-none ${className}`}>
    <div
      className={`relative rounded-2xl px-5 pb-2
                bg-[#1b1b22] text-white shadow-md
                flex flex-col items-center ${ballonClassName}`}
    >
      {children}
      <div
        className="absolute -bottom-3.5 left-1/2 -translate-x-1/2
                  w-0 h-0
                  border-l-[10px] border-r-[10px]
                  border-t-[14px]
                  border-l-transparent border-r-transparent
                  border-t-[#1b1b22]"
      />
    </div>
  </div>
)

export default TextBalloon
